export default "precision highp float;\nprecision highp int;\n#define GLSLIFY 1\n";